"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _Analytics = _interopRequireDefault(require("../analytics/Analytics"));

var _excluded = ["tag", "gaEvents", "onClick"];
var isIE11 = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/Trident\/7\.0/);

var TrackingLink = function TrackingLink(props) {
  var _props$tag = props.tag,
      Component = _props$tag === void 0 ? 'a' : _props$tag,
      gaEvents = props.gaEvents,
      onClick = props.onClick,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return (0, _preact.h)(Component, (0, _extends2.default)({}, restProps, {
    onClick: function onClick(e) {
      _publish.default.trackEvent('userevent', props.track);

      if (props.gaEvents) {
        _Analytics.default.send(props.gaEvents.eventCategory, props.gaEvents.eventAction, props.gaEvents.eventLabel);
      }

      if (typeof props.onClick === 'function') {
        props.onClick(e);
      } else if (props.href && isIE11 && typeof window !== 'undefined') {
        window.location.href = props.href;
      }
    }
  }), props.children);
};

var _default = TrackingLink;
exports.default = _default;